import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "STEP_1", {
  TITLE:
    "TELL US WHAT YOU THOUGHT OF OUR DIGITAL EVENTS, TRAININGS & EXPERIENCES.",
  TEXT_AREA_TITLE: "What do you want to see in 2022?",
  DONE: "Done",
});
